<template>
  <div
    :class="[
      'sidebar position-fixed top-0 h-100 shadow-sm',
      { 'sidebar-open': isOpen },
    ]"
  >
    <!-- Logo + Academy Name -->
    <div class="text-center py-4 border-bottom">
      <img
        src="@/assets/AxionLogo.png"
        alt="Axion Academy Logo"
        width="80"
        height="80"
        class="rounded-circle mb-2 neon-logo"
      />
      <h5 class="fw-bold glow-text">{{ academyName }}</h5>
    </div>

    <!-- Navigation Links -->
    <ul class="list-unstyled p-3 mt-3 flex-grow-1">
      <li v-for="link in links" :key="link.key" class="mb-2">
        <a
          href="#"
          class="sidebar-link d-flex align-items-center py-2 px-3 rounded text-decoration-none"
          :class="{ 'active-link': link.key === currentKey }"
          @click.prevent="handleClick(link.key)"
        >
          <i :class="['bi', link.icon, 'me-2']"></i>
          {{ link.name }}
        </a>
      </li>
    </ul>

    <!-- Footer -->
    <div class="text-center py-3 small text-white border-top border-pink">
      Powered by <strong>MySoftCode</strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: { type: Boolean, default: false },
  },
  emits: ["close-sidebar", "select-page"],
  data() {
    return {
      academyName: "Axion Academy",
      currentKey: "dashboard",
      links: [
        { key: "dashboard", name: "Dashboard", icon: "bi-speedometer2" },
        { key: "videos", name: "Videos", icon: "bi-play-btn" },
        { key: "profile", name: "Profile", icon: "bi-person-circle" },
      ],
    };
  },
  methods: {
    handleClick(key) {
      this.currentKey = key;
      this.$emit("select-page", key);
      this.$emit("close-sidebar");
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  left: -250px;
  background: linear-gradient(180deg, #1a001f, #2b0033);
  transition: left 0.3s ease;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  color: white;
}

/* Sidebar Open */
.sidebar-open {
  left: 0;
}

/* Links */
.sidebar-link {
  color: #ccc;
  font-weight: 500;
  transition: all 0.3s ease;
}

.sidebar-link:hover {
  background-color: rgba(255, 0, 204, 0.1);
  color: #ff00cc;
}

.active-link {
  background-color: rgba(255, 0, 204, 0.3);
  color: #ff00cc !important;
}

/* Glow Text */
.glow-text {
  color: #ff00cc;
  text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
}

/* Pink Border Top */
.border-pink {
  border-top: 1px solid #ff00cc;
}

/* Neon Logo Glow */
.neon-logo {
  box-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
}
</style>
